/** @format */

import { ScheduledActingAssignment, User } from '../store/application';
import { TimeBank } from './timeBank';
export interface Profile {
	user: User;
	configuration: Configuration[];
	delegatedTo: any[];
	delegatedFrom: any[];
	manage: ManageProfile[];
	managedGoneFromDNV: ManageProfile[];
	delegated: ManageProfile[];
	scheduledActings: ScheduledActingAssignment[];
	timeKeeper?: User;
	executiveAssistantFor: User[];
	timekeeperDelegated: ManageProfile[];
	timekeeperManagedUsers: ManageProfile[];
	allUsers: User[];
}

export interface Configuration {
	cdo: boolean;
	cdoDay: number;
	createdAt: Date;
	createdBy: number;
	durationOfModifiedDay: number;
	durationOfRegularDay: number;
	employmentStatus: string;
	hoursPerPayPeriod: number;
	id: number;
	modifiedDurationDay: number;
	startingDate: Date;
	userId: number;
	unionCode: string;
}

export interface ManageProfile {
	user: User;
	configurations: Configuration[];
	scheduledActings: ScheduledActingAssignment[];
	timeBanks: TimeBank[];
}

// this is temporary to fix
// entry-form.component.ts:23:3 - error TS2564: Property 'currentConfiguration' has no initializer and is not definitely assigned in the constructor.
export const blankConfiguration: Configuration = {
	cdo: false,
	cdoDay: 0,
	createdAt: new Date(),
	createdBy: 0,
	durationOfModifiedDay: 0,
	durationOfRegularDay: 7,
	employmentStatus: '',
	hoursPerPayPeriod: 70,
	id: -1,
	modifiedDurationDay: 0,
	startingDate: new Date(),
	userId: -1,
	unionCode: '',
};
